import { computed } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';

/**
 * Composable to determine if the current user has administrator access.
 * @returns {Boolean} - True if the current user has administrator access, false otherwise.
 */
export function useAdmin() {
  const getters = useStoreGetters();

  const currentUserRole = computed(() => getters.getCurrentRole.value);
  const isAdmin = computed(() =>
    ['administrator', 'owner'].includes(currentUserRole.value)
  );

  return {
    isAdmin,
  };
}
